'use es6';

import { ACTIVATE_DEVELOPER_MODE } from 'ContentEditorUI/redux/actions/actionTypes';
export const activateDeveloperMode = () => {
  return {
    type: ACTIVATE_DEVELOPER_MODE
  };
};